import ActionType from './ActionType'
// import { emailDataSelector } from '../selectors'
// import DynamoDB from 'aws-sdk/clients/dynamodb'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'

export const clickContactToEmail = (payload) => (dispatch) =>
	dispatch({
		type: ActionType.Email.CLICK_CONTACT_TO_EMAIL,
		payload,
	})

export const handleSubjectChange = (name, value) => (dispatch) =>
	dispatch({
		type: ActionType.Email.HANDLE_SUBJECT_CHANGE,
		payload: { name, value },
	})

export const handleMultiChange = (newValue) => (dispatch) =>
	dispatch({
		type: ActionType.Email.HANDLE_TO_CHANGE,
		payload: { newValue },
	})

export const handleBodyChange = (string, anotherstring) => (dispatch) =>
	dispatch({
		type: ActionType.Email.HANDLE_BODY_CHANGE,
		payload: string,
		anotherstring,
	})

export const sendEmail =
  (toValue, inbox = null, extraData = null, bodyOverride) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const subject = getState().email.subject.value
      const body = bodyOverride || getState().editor

      const settings = getState().AccountSettings.settings
      const preferences = getState().AccountSettings.preferences
      const from =
        extraData?.from || preferences?.preferences?.default_email_from
      const from_name =
        extraData?.from_name ||
        settings.business_name ||
        settings.name ||
        'Vast Reach'

      // const data = {
      //   email_messages: inbox
      //     ? [
      //         {
      //           to: getState().inbox.to.current.value,
      //           // client_id: '0',
      //           from,
      //           from_name,
      //           subject,
      //           body,
      //         },
      //       ]
      //     : toValue.map((el, idx) => {
      //         return {
      //           to: [el.value],
      //           client_id: `${idx}`,
      //           from,
      //           from_name,
      //           subject,
      //           body,
      //         }
      //       }),
      // }

      const data = {
        to: getState().inbox.to.current.value,
        from,
        from_name,
        subject,
        body,
        contact_id: extraData.contact_id,
      }

      dispatch({
        type: ActionType.Email.SEND_REQUEST,
        payload: data,
        inbox,
        extraData,
      })

      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(`${API_URL}/email/sendone`, {
            body: JSON.stringify(data), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Email.SEND_FAILURE,
                  payload,
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.Email.SEND_SUCCESS,
                payload,
              })
              resolve(payload)
            })
            .catch(error => {
              dispatch({
                type: ActionType.Email.SEND_FAILURE,
                payload: error,
              })
              reject(error)
            })
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    })

/*export const saveEmail = () => (dispatch, getState) => {
  dispatch({ type: ActionType.Email.SAVE_REQUEST })

  const dynamodb = new DynamoDB({
    apiVersion: '2012-08-10',
    credentials: Auth.essentialCredentials(getState().auth.credentials)
  })

  const params = {
    Item: {
      subject: { S: 'something something subject' },
      toValue: {
        L: [
          {
            M: {
              contactID: { S: '2' },
              label: { S: 'Colleen McCann' },
              key: { S: '2SelectValue' },
            },
          }
        ],
      },
      body: {
        M: {
          document: {
            M: {
              nodes: {
                L: [
                  {
                    M: {
                      object: { S: 'block' },
                      type: { S: 'paragraph' },
                      nodes: {
                        L: [
                          {
                            M: {
                              object: { S: 'text' },
                              leaves: {
                                L: [
                                  {
                                    M: {
                                      text: { S: ' ' },
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                ],
              },
            },
          },
        },
      },
    },
    ReturnConsumedCapacity: 'TOTAL',
    TableName: 'Emails',
  }

  return dynamodb.putItem(params, (error, payload) => {
    if (error) {
      dispatch({
        type: ActionType.Email.SAVE_FAILURE,
        payload: error
      })
    } else {
      dispatch({
        type: ActionType.Email.SAVE_SUCCESS,
        payload
      })
    }
  })
}*/
